import {Chip as MantineChip, ChipGroupProps, ChipProps} from '@mantine/core';
import {AdapterProps, FieldAdapter} from '../field-factory';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $ChipGroupAdapterProps = AdapterProps<ChipGroupProps<boolean>>;

export const $ChipGroupAdapter: FC<FieldAdapter<$ChipGroupAdapterProps>> = (
  props
) => {
  const {
    inputProps: {onChange, ...inputProps},
    control,
  } = props;
  const {
    field: {value, onChange: fieldOnChange, ref: _, ...fieldProps},
  } = control;

  const _onChange = (value: string | string[]) => {
    fieldOnChange(value);
    onChange?.(value);
  };

  return (
    <MantineChip.Group
      onChange={_onChange}
      value={value}
      {...fieldProps}
      {...inputProps}
    />
  );
};

export const $ChipGroupItemAdapter = ({disabled, ...props}: ChipProps) => {
  const {readOnly} = useContext(ReadOnlyContext);
  return <MantineChip {...props} disabled={disabled || readOnly} />;
};